import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";

export class ZIDXAccountAIBotEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountAIBotEditContainer";
    }
    render(){
        // console.log("AI Bots");
    }
}